import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Idle, DocumentInterruptSource, StorageInterruptSource } from '@ng-idle/core';
import { SecurityService } from '@core/Security/security.service';
import { EventsEmitterService } from '@core/Abstract/emitter.service';
import { LogService } from '@core/Abstract/log.service';
import { ConfigService } from '@core/Abstract/config.service';
import { VisualsService } from '@core/Abstract/visuals.service';
import { AuthService } from '../../../../Core/Auth/auth.service';

@Component({
    selector: 'app-timer',
    template: `
    <ol class="container-fluid">
            <!-- Logout Timer -->
            <div *ngIf="timerActive" class="timer float-md-right"> 
                <div class="inner animating" [ngClass]="{animating: resetTimerAnimation}">        
                    <div class="bg-circle"></div>        
                    <div class="counter">{{timer}}</div>        
                    <div class="pie spinner"></div>        
                    <div class="pie filler"></div>        
                    <div class="mask"></div>    
                </div>
            </div>
        </ol>
  `
})
export class TimerComponent implements OnInit, OnDestroy {

    private CUSTOM_INTERRUPTSOURCE: any[] = [new DocumentInterruptSource(
        'keydown mousedown'), new StorageInterruptSource()];

    protected resetTimerAnimation: boolean = true;
    protected timer: string;
    protected timerActive: boolean;

    constructor(private securityService: SecurityService,
        private eventsEmitterService: EventsEmitterService,
        private logger: LogService,
        public authService: AuthService,
        private configService: ConfigService,
        private visualsService: VisualsService,
        private idle: Idle) {

        this.drawTimer(configService.getTimerSeconds());
    }

    ngOnInit(): void { }

    ngOnDestroy() {
        // Will clear when component is destroyed e.g. route is navigated away from.
        this.idle.stop();
        this.idle.onIdleStart.observers.length = 0;
        this.idle.onIdleEnd.observers.length = 0;
        this.idle.onTimeoutWarning.observers.length = 0;
        this.idle.onTimeout.observers.length = 0;
        this.idle.onInterrupt.observers.length = 0;
    }

    @HostListener('window:visibilitychange', ['$event'])
    visibilitychange() {
        let mins: number = +this.timer.split(':')[0] * 60;
        let secs: number = +this.timer.split(':')[1];
        let totalCountdown= mins + secs;
        this.drawTimer(totalCountdown);
    }

    protected drawTimer(countdownSeconds: number) {
        // disable Timer from config file during tests
        this.timerActive = this.configService.getTimer();
        if (this.timerActive) {
            // sets an idle timeout of 1 seconds, for testing purposes.
            this.idle.setIdle(1);
            // sets a timeout period of 5 seconds. after 10 minutes of inactivity, the user will be considered timed out.
            this.idle.setTimeout(countdownSeconds);
            // sets the custom interrupts, in this case, things like clicks, scrolls, touches to the document
            this.idle.setInterrupts(this.CUSTOM_INTERRUPTSOURCE);

            this.idle.onInterrupt.subscribe(() => {
                this.resetTimerAnimation = false;
            });

            this.idle.onTimeoutWarning.subscribe((countdown: number) => {
                this.resetTimerAnimation = true;
                this.timer = this.formatTime(countdown);
                //this.logger.log('TimeoutWarning: ' + countdown);
            });

            this.idle.onTimeout.subscribe(() => {
                this.authService.logout(true);
            });

            this.idle.watch();
        }
    }

    protected formatTime(time: number): string {
        let minutes = Math.floor(time / 60);
        let seconds = time - minutes * 60;
        let finalTime = this.str_pad_left(minutes, '0', 2) + ':' + this.str_pad_left(seconds, '0', 2);
        return finalTime;
    }

    protected str_pad_left(string, pad, length) {
        return (new Array(length + 1).join(pad) + string).slice(-length);
    }

}
